'use client';

import { Button, toast, useField, useFormFields } from '@payloadcms/ui';
import { TextFieldClientProps } from 'payload';
import React from 'react';

export const FineTune: React.FC<TextFieldClientProps> = ({ path }) => {
  const appKey = useFormFields(
    ([fields]) => fields['settings.credentials.appKey']
  );
  const apiKey = useFormFields(
    ([fields]) => fields['settings.credentials.apiKey']
  );
  const { setValue } = useField<string>({
    path: 'settings.fineTuning.currentJobId',
  });

  const appKeyValue = appKey?.initialValue;
  const apiKeyValue = apiKey?.initialValue;

  const handleClick = async () => {
    if (!appKeyValue || !apiKeyValue) {
      return;
    }
    const httpResponse = await fetch((process.env.PAYLOAD_PUBLIC_BASE_PATH || '') + '/api/llm/fine-tuning?locale=it', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      referrer: '',
      body: JSON.stringify({
        appKey: appKeyValue,
        apiKey: apiKeyValue,
      }),
    });
    const response = await httpResponse.json();
    if (httpResponse.ok) {
      setValue(response.id);
      toast.success('Job avviato con successo');
    } else {
      toast.error(response.message);
    }
  };

  return (
    <div>
      <Button onClick={handleClick}>Avvia nuovo job</Button>
    </div>
  );
};
